import { createSlice } from '@reduxjs/toolkit';

import type { DropdownOption } from './types';

import { fetchDropdownOptions } from './dropdownOptionsActions';
import { buildDropdownOptionsCacheKey } from './dropdownOptionsUtils';

type DropdownOptionsCacheEntry = {
  items: DropdownOption[];
  loading: boolean;
  error?: string;
  fetchedAt?: number;
};

type DropdownOptionsState = {
  byKey: Record<string, DropdownOptionsCacheEntry>;
};

const initialState: DropdownOptionsState = {
  byKey: {}
};

export const dropdownOptionsSlice = createSlice({
  name: 'dropdownOptionsSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDropdownOptions.pending, (state, action) => {
        const cacheKey = buildDropdownOptionsCacheKey(action.meta.arg);
        const previous = state.byKey[cacheKey];

        state.byKey[cacheKey] = {
          items: previous?.items || [],
          loading: true,
          error: undefined,
          fetchedAt: previous?.fetchedAt
        };
      })
      .addCase(fetchDropdownOptions.fulfilled, (state, action) => {
        const { cacheKey, items } = action.payload;

        state.byKey[cacheKey] = {
          items,
          loading: false,
          error: undefined,
          fetchedAt: Date.now()
        };
      })
      .addCase(fetchDropdownOptions.rejected, (state, action) => {
        const cacheKey = buildDropdownOptionsCacheKey(action.meta.arg);
        const previous = state.byKey[cacheKey];

        state.byKey[cacheKey] = {
          items: previous?.items || [],
          loading: false,
          error:
            typeof action.payload === 'string'
              ? action.payload
              : action.error.message || 'Unable to load dropdown options',
          fetchedAt: previous?.fetchedAt
        };
      });
  }
});

export default dropdownOptionsSlice.reducer;
